<div id="layout-wrapper" style="background-color: #d5e2f8;">
  

  <app-topbar (settingsButtonClicked)="onSettingsButtonClicked()" (mobileMenuButtonClicked)="onToggleMobileMenu()">
  </app-topbar>

  <app-sidebar [isCondensed]="isCondensed" (mobileMenuButtonClicked)="onToggleMobileMenu()"></app-sidebar>

  <div class="main-content" style="background-color: #d5e2f8;" >
    <div class="page-content" style="background-color: #d5e2f8;" >
      
      <!-- content -->
      <router-outlet></router-outlet>
    </div>

    <!-- footer -->
    <div class="fixed-bottom"  style="background-color: #d5e2f8;" ></div>
    <app-footer></app-footer>
  </div>
</div>

<app-rightsidebar></app-rightsidebar>
